import { Col, Form, Input, Label, Row } from "reactstrap";
import Select from "../../Common/AppSelect";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import {
  getTasksCrmITList,
  searchTaskList,
} from "../../../store/tasksCrmIT/action";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { AppDatePicker } from "../../Common/AppDateTimePicker";
import { getSingleJobRecentActivityList } from "../../../store/singleJob/action";
import {
  createOpportunitiesItem,
  createOpportunitiesItemSuccess,
  createOpportunityProductItem,
  getAllOpportunitiesList,
  opportunitiesPriorityList,
  opportunitiesStatusList,
  opportunitiesTypeList,
  searchSingleCustomerOpportunitiesList,
  updateOpportunitiesItem,
  updateOpportunitiesItemSuccess,
} from "../../../store/opportunities/action";
import { getStaffList } from "../../../store/staff/action";
import filterActiveStaff from "../../Common/staffActive";
import { getCustomersListData } from "../../../store/customers/action";
import { getJobsData } from "../../../store/jobsList/actions";
import { getProductList } from "../../../store/product/action";
import { toast } from "react-toastify";
import CreateEditCustomer from "../CreateEditCustomer/CreateEditCustomer";
import AppModal from "../../Common/AppModal";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
// Change #100067 - retired products are not offered when adding a line.
import { isProductActive } from "../../../helpers/functions/productActive";

export default function CreateEditOpportunityPopUp({
  modalOpportunity,
  setModalOpportunity,
  toggleOpportunity,
  isCreate,
  isEdit,
  EditData,
  Customer_Id,
  Job_Id,
  Single_Customer,
  Single_Job,
  Single_Recent_Activity,
  ShowJobList,
  TaskList,
  OpportunitiesList,
  standAlone,
}) {
  const dispatch = useDispatch();

  // get filters data from state
  const { customersList } = useSelector((state) => ({
    customersList: state.Customers?.customersDataList?.customer_list,
  }));

  // get staff members data from state
  const { staffData } = useSelector((state) => ({
    staffData: state.Staff.staffList?.staff_list,
  }));

  const { opportunitiesStatusListData } = useSelector((state) => ({
    opportunitiesStatusListData:
      state.Opportunities.opportunitiesStatusList?.opportunitystatus_list,
  }));
  const { opportunitiesPriorityListData } = useSelector((state) => ({
    opportunitiesPriorityListData:
      state.Opportunities.opportunitiesPriorityList?.opportunitypriority_list,
  }));
  const { opportunitiesTypeListData } = useSelector((state) => ({
    opportunitiesTypeListData:
      state.Opportunities.opportunitiesTypeList?.opportunitytype_list,
  }));
  const { jobsList } = useSelector((state) => ({
    jobsList: state.Jobs.jobsData?.job_list,
  }));

  // catalogue products for the "interested products" picker
  const { productList } = useSelector((state) => ({
    productList: state.ProductCrmIT.productList?.product_list,
  }));

  useEffect(() => {
    if (!standAlone) return;
    dispatch(getStaffList());
    dispatch(getCustomersListData());
    dispatch(opportunitiesStatusList());
    dispatch(opportunitiesPriorityList());
    dispatch(opportunitiesTypeList());
    if (isEmpty(jobsList)) {
      dispatch(getJobsData());
    }
  }, [standAlone]);

  // products are needed regardless of how the modal was opened
  useEffect(() => {
    if (isEmpty(productList)) {
      dispatch(getProductList());
    }
  }, []);
  const handleDateFormat = (e) => {
    // received format [Wed Dec 14 2022 00:00:00 GMT+0000 (Greenwich Mean Time)] change to 2022-12-14
    // convert month name to number
    const month_to_number = (month) => {
      const months = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12",
      };
      return months[month];
    };

    const receivedDate = e.toString();
    const date = receivedDate.split(" ");
    const year = date[3];
    const month = date[1];
    const day = date[2];
    return `${year}-${month_to_number(month)}-${day}`;
  };

  const [singleItemCreateUpdate, setSingleItemCreateUpdate] = useState({
    Id: "",
    Title: "",
    Description: "",
    Customer_Id: Customer_Id ? Customer_Id : "",
    ContactPerson: "",
    Notes: "",
    Staff_Id: "",
    Project: "",
    OpportunityType_Id: "",
    OpportunityPriority_Id: "",
    OpportunityStatus_Id: "",
    Job_Id: Job_Id ? Job_Id : "",
    DueDateTime: handleDateFormat(new Date()),
  });

  useEffect(() => {
    if (isCreate) {
      setSingleItemCreateUpdate({
        Id: "",
        Title: "",
        Description: "",
        Customer_Id: Customer_Id ? Customer_Id : "",
        ContactPerson: "",
        Notes: "",
        Staff_Id: "",
        Project: "",
        OpportunityType_Id: "",
        OpportunityPriority_Id: "",
        OpportunityStatus_Id: "",
        Job_Id: Job_Id ? Job_Id : "",
        DueDateTime: handleDateFormat(new Date()),
      });
      setInterestedProducts([]);
      setProductPicker(null);
      setProductQty(1);
    }
  }, [isCreate]);

  // Helper Functions to dispatch ai  to get new list updated data
  const handleHelperCustomerTaskList = () => {
    const TaskList = [
      {
        task_data: {
          Customer_Id,
        },
      },
    ];
    dispatch(searchTaskList(TaskList));
  };
  const handleHelperJobTaskList = () => {
    const TaskList = [
      {
        task_data: {
          Job_Id,
        },
      },
    ];
    dispatch(searchTaskList(TaskList));
  };

  const [singleStaffUpdate, setSingleStaffUpdate] = useState([]);
  const [singleProjectUpdate, setSingleProjectUpdate] = useState([]);
  const [singleCustomerUpdate, setSingleCustomerUpdate] = useState([]);
  // Change #100150 - "ability to create customer on this screen". Opens the
  // standard customer form on top of this one; on save the new customer is
  // selected here, so nothing typed into the opportunity is lost.
  const [modalCreateCustomer, setModalCreateCustomer] = useState(false);
  const handleCustomerCreated = (customerData, details) => {
    const id = customerData?.Id;
    if (!id) return;
    const label =
      (details?.CustomerBusinessType_Id === "1"
        ? details?.BusinessName
        : [details?.PersonFirstName, details?.PersonLastName]
            .filter(Boolean)
            .join(" ")) || `Customer #${id}`;
    setSingleCustomerUpdate({ label, value: id, id });
    setSingleItemCreateUpdate((prev) => ({ ...prev, Customer_Id: id }));
  };
  const [singleOpportunityStatusUpdate, setSingleOpportunityStatusUpdate] =
    useState([]);
  const [singleOpportunityPriorityUpdate, setSingleOpportunityPriorityUpdate] =
    useState([]);
  const [singleTaskTypeUpdate, setSingleTaskTypeUpdate] = useState([]);
  const [singleJobUpdate, setSingleJobUpdate] = useState([]);
  const [localOportunityPopUpUpdate, setLocalOportunityPopUpUpdate] =
    useState(false);

  // interested products / services selected while creating the opportunity
  const [interestedProducts, setInterestedProducts] = useState([]);
  const [productPicker, setProductPicker] = useState(null);
  const [productQty, setProductQty] = useState(1);

  const handleAddInterestedProduct = () => {
    if (!productPicker?.id) {
      toast.error("Please select a product or service");
      return;
    }
    if (interestedProducts.some((p) => p.Product_Id === productPicker.id)) {
      toast.error("That product is already in the list");
      return;
    }
    setInterestedProducts([
      ...interestedProducts,
      {
        Product_Id: productPicker.id,
        Product_Name: productPicker.label,
        Quantity: productQty === "" ? 1 : productQty,
      },
    ]);
    setProductPicker(null);
    setProductQty(1);
  };

  const handleRemoveInterestedProduct = (productId) => {
    setInterestedProducts(
      interestedProducts.filter((p) => p.Product_Id !== productId)
    );
  };
  useEffect(() => {
    if (!isEmpty(EditData)) {
      setSingleItemCreateUpdate({
        Id: EditData?.Id,
        Title: EditData?.Title,
        Description: EditData?.Description,
        Customer: EditData?.Customer_Id,
        ContactPerson: EditData?.ContactPerson_Id,
        Notes: EditData?.Notes,
        Staff_Id: EditData?.Staff_Id,
        Project: EditData?.Project_Id,
        OpportunityType_Id: EditData?.OpportunityType_Id,
        OpportunityPriority_Id: EditData?.OpportunityPriority_Id,
        OpportunityStatus_Id: EditData?.OpportunityStatus_Id,
        Job_Id: EditData?.Job_Id,
        DueDateTime: EditData?.DueDateTime,
      });

      // setSingleContactPersonUpdate(""); // TODO: API needs to be fixed
      setSingleStaffUpdate({
        label:
          staffData?.find((staff) => staff.Id === EditData?.Staff_Id)
            ?.FirstName &&
          staffData?.find((staff) => staff.Id === EditData?.Staff_Id)?.LastName
            ? staffData?.find((staff) => staff.Id === EditData?.Staff_Id)
                ?.FirstName +
              " " +
              staffData?.find((staff) => staff.Id === EditData?.Staff_Id)
                ?.LastName
            : "Unassigned",
        value: staffData?.find((staff) => staff.Id === EditData?.Staff_Id)?.Id,
        id: staffData?.find((staff) => staff.Id === EditData?.Staff_Id)?.Id,
      });
      setSingleProjectUpdate(""); // TODO: API needs to be fixed
      setSingleCustomerUpdate({
        label: customersList?.find(
          (customer) => customer.Id === EditData?.Customer_Id
        )?.FullName,
        value: customersList?.find(
          (customer) => customer.Id === EditData?.Customer_Id
        )?.Id,
        id: customersList?.find(
          (customer) => customer.Id === EditData?.Customer_Id
        )?.Id,
      });
    }
    setSingleOpportunityStatusUpdate({
      label: opportunitiesStatusListData?.find(
        (status) => status.Id === EditData?.OpportunityStatus_Id
      )?.Name,
      value: opportunitiesStatusListData?.find(
        (status) => status.Id === EditData?.OpportunityStatus_Id
      )?.Id,
      id: opportunitiesStatusListData?.find(
        (status) => status.Id === EditData?.OpportunityStatus_Id
      )?.Id,
    });
    setSingleOpportunityPriorityUpdate({
      label: opportunitiesPriorityListData?.find(
        (priority) => priority.Id === EditData?.OpportunityPriority_Id
      )?.Name,
      value: opportunitiesPriorityListData?.find(
        (priority) => priority.Id === EditData?.OpportunityPriority_Id
      )?.Id,
      id: opportunitiesPriorityListData?.find(
        (priority) => priority.Id === EditData?.OpportunityPriority_Id
      )?.Id,
    });
    setSingleTaskTypeUpdate({
      label: opportunitiesTypeListData?.find(
        (type) => type.Id === EditData?.OpportunityType_Id
      )?.Name,
      value: opportunitiesTypeListData?.find(
        (type) => type.Id === EditData?.OpportunityType_Id
      )?.Id,
      id: opportunitiesTypeListData?.find(
        (type) => type.Id === EditData?.OpportunityType_Id
      )?.Id,
    });
    setSingleJobUpdate({
      label:
        "#" +
        EditData?.Job_Id +
        " " +
        jobsList?.find((job) => job.Id === EditData?.Job_Id)?.Title,
      value: EditData?.Job_Id,
      id: EditData?.Job_Id,
    });
  }, [EditData]);

  // Handle Update Create Task
  const handleUpdateCreateOpportunity = () => {
    // Check if title is empty
    if (singleItemCreateUpdate.Title === "") {
      toast.error("Title is required");
      return;
    }
    // ceck if customer selected
    if (singleItemCreateUpdate.Customer_Id === "") {
      toast.error("Please select Customer");
      return;
    }
    // Status id
    if (singleItemCreateUpdate.OpportunityStatus_Id === "") {
      toast.error("Please select Status");
      return;
    }

    if (isEdit) {
      dispatch(updateOpportunitiesItem([singleItemCreateUpdate]));
      setLocalOportunityPopUpUpdate(true);
    }
    if (isCreate) {
      dispatch(createOpportunitiesItem([singleItemCreateUpdate]));
      setSingleItemCreateUpdate({
        Id: "",
        Title: "",
        Description: "",
        Customer_Id: Customer_Id ? Customer_Id : "",
        ContactPerson: "",
        Notes: "",
        Staff_Id: "",
        Project: "",
        OpportunityType_Id: "",
        OpportunityPriority_Id: "",
        OpportunityStatus_Id: "",
        Job_Id: Job_Id ? Job_Id : "",
        DueDateTime: new Date(),
      });
    }
  };

  const {
    createOpportunitiesItemSuccessAPI,
    createOpportunitiesItemSuccessLoading,
  } = useSelector((state) => ({
    createOpportunitiesItemSuccessAPI:
      state.Opportunities.createOpportunitiesItemSuccess,
    createOpportunitiesItemSuccessLoading:
      state.Opportunities.createOpportunitiesItemSuccessLoading,
  }));
  const localStaffId = JSON.parse(localStorage.getItem("authUser"))
    ?.get_staff_data?.Staff_Id;

  useEffect(() => {
    if (isEmpty(createOpportunitiesItemSuccessAPI)) return;
    if (createOpportunitiesItemSuccessAPI.status === 200) {
      toast.success(createOpportunitiesItemSuccessAPI.message);

      // attach any interested products to the newly created opportunity
      const newOpportunityId =
        createOpportunitiesItemSuccessAPI.New_Opportunity_Id;
      if (newOpportunityId && !isEmpty(interestedProducts)) {
        dispatch(
          createOpportunityProductItem(
            interestedProducts.map((p) => ({
              Opportunity_Id: newOpportunityId,
              Product_Id: p.Product_Id,
              Quantity: p.Quantity,
              Notes: "",
              CreatedStaffId: localStaffId,
            }))
          )
        );
      }
      setInterestedProducts([]);
      setModalOpportunity(false);
      helperDispatch();
    } else {
      toast.error(createOpportunitiesItemSuccessAPI.message);
    }

    dispatch(createOpportunitiesItemSuccess([]));
  }, [createOpportunitiesItemSuccessAPI]);

  const {
    updateOpportunitiesItemSuccessAPI,
    updateOpportunitiesItemSuccessLoading,
  } = useSelector((state) => ({
    updateOpportunitiesItemSuccessAPI:
      state.Opportunities.updateOpportunitiesItemSuccess,
    updateOpportunitiesItemSuccessLoading:
      state.Opportunities.updateOpportunitiesItemSuccessLoading,
  }));
  const helperDispatch = () => {
    if (!singleCustomerUpdate && !singleJobUpdate) {
      dispatch(getTasksCrmITList());
    }
    // Dispatch for Single Job tab
    if (Single_Job) {
      handleHelperJobTaskList();
    }
    if (OpportunitiesList) {
      dispatch(getAllOpportunitiesList());
    }
    // Dispatch for Single Customer tab
    if (Single_Customer) {
      dispatch(
        searchSingleCustomerOpportunitiesList([
          {
            customer_data: {
              Id: Customer_Id,
            },
          },
        ])
      );
    }

    if (Single_Recent_Activity) {
      dispatch(getSingleJobRecentActivityList({ id: Job_Id }));
    }
    if (TaskList) {
      dispatch(getTasksCrmITList());
    }
  };

  useEffect(() => {
    if (isEmpty(updateOpportunitiesItemSuccessAPI)) return;
    if (!localOportunityPopUpUpdate) return;
    if (updateOpportunitiesItemSuccessAPI?.status === 200) {
      toast.success(updateOpportunitiesItemSuccessAPI?.message);
      setModalOpportunity(false);
      helperDispatch();
    } else {
      toast.error(updateOpportunitiesItemSuccessAPI?.message);
    }
    setLocalOportunityPopUpUpdate(false);
    dispatch(updateOpportunitiesItemSuccess([]));
  }, [updateOpportunitiesItemSuccessAPI]);
  return (
    <>
    {modalCreateCustomer && (
      <CreateEditCustomer
        modalCreateCustomer={modalCreateCustomer}
        setModalCreateCustomer={setModalCreateCustomer}
        toggleCreateCustomer={() => setModalCreateCustomer(false)}
        onCustomerCreated={handleCustomerCreated}
      />
    )}
    <AppModal
      open={modalOpportunity}
      onClose={toggleOpportunity}
      title={
        isEdit
          ? "Edit Opportunity # " + singleItemCreateUpdate.Id
          : "Create New Opportunity"
      }
      icon={<LightbulbOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      loading={
        createOpportunitiesItemSuccessLoading ||
        updateOpportunitiesItemSuccessLoading
      }
      loadingText="Saving…"
      onSubmit={handleUpdateCreateOpportunity}
      submitLabel={isEdit ? "Update" : "Create"}
      submitColor="success"
    >
      {isCreate || isEdit ? (
        <>
          <Input type="hidden" id="id-field" />
              <Row className="g-3">
                <Col lg={12}>
                  <div>
                    <Label htmlFor="name-field" className="form-label">
                      Opportunity Title
                    </Label>

                    <Input
                      name="Title"
                      id="Title"
                      className="form-control"
                      placeholder={
                        !!isEdit
                          ? singleItemCreateUpdate.Title
                          : `Create Opportunity Title`
                      }
                      type="text"
                      validate={{
                        required: { value: true },
                      }}
                      onChange={(e) => {
                        setSingleItemCreateUpdate({
                          ...singleItemCreateUpdate,
                          Title: e.target.value,
                        });
                      }}
                      value={
                        !!isEdit
                          ? singleItemCreateUpdate.Title || ""
                          : singleItemCreateUpdate.Title || ""
                      }
                    />
                  </div>
                </Col>
                <Col lg={12}>
                  <div>
                    <Label htmlFor="company_name-field" className="form-label">
                      Opportunity Description
                    </Label>
                    <Input
                      name="Description"
                      id="Description"
                      className="form-control"
                      placeholder={
                        !!isEdit
                          ? singleItemCreateUpdate.Description
                          : `Create Opportunity Description`
                      }
                      type="text"
                      validate={{
                        required: { value: true },
                      }}
                      onChange={(e) => {
                        setSingleItemCreateUpdate({
                          ...singleItemCreateUpdate,
                          Description: e.target.value,
                        });
                      }}
                      value={
                        !!isEdit
                          ? singleItemCreateUpdate.Description || ""
                          : singleItemCreateUpdate.Description || ""
                      }
                    />
                  </div>
                </Col>

                {!Single_Customer && (
                  <Col lg={12}>
                    <div>
                      <Label
                        htmlFor="company_name-field"
                        className="form-label"
                      >
                        Customer
                      </Label>
                      {/* Change #100150 - create a customer without leaving. */}
                      <button
                        type="button"
                        className="btn btn-link btn-sm p-0 ms-2 align-baseline"
                        onClick={() => setModalCreateCustomer(true)}
                      >
                        <i className="fa-solid fa-plus me-1" />
                        New customer
                      </button>
                      {!!isEdit ? (
                        <div>
                          <Select
                            className="mb-0 job-select2"
                            value={singleCustomerUpdate}
                            onChange={(e) => {
                              setSingleCustomerUpdate(e);
                              setSingleItemCreateUpdate({
                                ...singleItemCreateUpdate,
                                Customer_Id: e.id,
                              });
                            }}
                            options={
                              !isEmpty(customersList)
                                ? customersList?.map((item) => ({
                                    label: item.FullName,
                                    value: item.Id,
                                    id: item.Id,
                                  }))
                                : []
                            }
                            id="country-select"
                          ></Select>
                        </div>
                      ) : (
                        <div>
                          <Select
                            className="mb-0 job-select2"
                            value={singleCustomerUpdate}
                            onChange={(e) => {
                              setSingleCustomerUpdate(e);
                              setSingleItemCreateUpdate({
                                ...singleItemCreateUpdate,
                                Customer_Id: e.id,
                              });
                            }}
                            options={
                              !isEmpty(customersList)
                                ? customersList?.map((item) => ({
                                    label: item.FullName,
                                    value: item.Id,
                                    id: item.Id,
                                  }))
                                : []
                            }
                            id="country-select"
                          ></Select>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                {ShowJobList && (
                  <Col lg={12}>
                    <div>
                      <Label
                        htmlFor="company_name-field"
                        className="form-label"
                      >
                        Job
                      </Label>
                      {!!isEdit ? (
                        <div>
                          <Select
                            className="mb-0 job-select2"
                            placeholder={"Select Job"}
                            value={singleJobUpdate}
                            onChange={(e) => {
                              setSingleJobUpdate(e);
                              setSingleItemCreateUpdate({
                                ...singleItemCreateUpdate,
                                Job_Id: e.id,
                              });
                            }}
                            options={
                              !isEmpty(jobsList)
                                ? jobsList?.map((item) => ({
                                    label: "#" + item?.Id + " " + item?.Title,
                                    value: item?.Id,
                                    id: item?.Id,
                                  }))
                                : []
                            }
                            id="country-select"
                          ></Select>
                        </div>
                      ) : (
                        <div>
                          <Select
                            placeholder={"Select Job"}
                            className="mb-0 job-select2"
                            value={singleJobUpdate}
                            onChange={(e) => {
                              setSingleJobUpdate(e);
                              setSingleItemCreateUpdate({
                                ...singleItemCreateUpdate,
                                Job_Id: e.id,
                              });
                            }}
                            options={
                              !isEmpty(jobsList)
                                ? jobsList?.map((item) => ({
                                    label: "#" + item?.Id + " " + item?.Title,
                                    value: item?.Id,
                                    id: item?.Id,
                                  }))
                                : []
                            }
                            id="country-select"
                          ></Select>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  <div>
                    <Label htmlFor="company_name-field" className="form-label">
                      Staff
                    </Label>
                    {!!isEdit ? (
                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={singleStaffUpdate}
                          onChange={(e) => {
                            setSingleStaffUpdate(e);
                            setSingleItemCreateUpdate({
                              ...singleItemCreateUpdate,
                              Staff_Id: e.id,
                            });
                          }}
                          options={
                            !isEmpty(staffData)
                              ? filterActiveStaff(staffData, [
                                  singleItemCreateUpdate?.Staff_Id,
                                ])?.map((item) => ({
                                  label: item?.FirstName + " " + item?.LastName,
                                  value: item?.Id,
                                  id: item?.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    ) : (
                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={singleStaffUpdate}
                          onChange={(e) => {
                            setSingleStaffUpdate(e);
                            setSingleItemCreateUpdate({
                              ...singleItemCreateUpdate,
                              Staff_Id: e.id,
                            });
                          }}
                          options={
                            !isEmpty(staffData)
                              ? filterActiveStaff(staffData, [
                                  singleItemCreateUpdate?.Staff_Id,
                                ])?.map((item) => ({
                                  label: item?.FirstName + " " + item?.LastName,
                                  value: item?.Id,
                                  id: item?.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    )}
                  </div>
                </Col>
                <Col lg={12}>
                  <div>
                    <Label htmlFor="company_name-field" className="form-label">
                      Opportunity Status
                    </Label>
                    {!!isEdit ? (
                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={singleOpportunityStatusUpdate}
                          onChange={(e) => {
                            setSingleOpportunityStatusUpdate(e);
                            setSingleItemCreateUpdate({
                              ...singleItemCreateUpdate,
                              OpportunityStatus_Id: e.id,
                            });
                          }}
                          options={
                            !isEmpty(opportunitiesStatusListData)
                              ? opportunitiesStatusListData.map((item) => ({
                                  label: item.Name,
                                  value: item.Id,
                                  id: item.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    ) : (
                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={singleOpportunityStatusUpdate}
                          onChange={(e) => {
                            setSingleOpportunityStatusUpdate(e);
                            setSingleItemCreateUpdate({
                              ...singleItemCreateUpdate,
                              OpportunityStatus_Id: e.id,
                            });
                          }}
                          options={
                            !isEmpty(opportunitiesStatusListData)
                              ? opportunitiesStatusListData.map((item) => ({
                                  label: item.Name,
                                  value: item.Id,
                                  id: item.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    )}
                  </div>
                </Col>
                <Col lg={12}>
                  <div>
                    <Label htmlFor="company_name-field" className="form-label">
                      Opportunity Type
                    </Label>
                    {!!isEdit ? (
                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={singleTaskTypeUpdate}
                          onChange={(e) => {
                            setSingleTaskTypeUpdate(e);
                            setSingleItemCreateUpdate({
                              ...singleItemCreateUpdate,
                              OpportunityType_Id: e.id,
                            });
                          }}
                          options={
                            !isEmpty(opportunitiesTypeListData)
                              ? opportunitiesTypeListData?.map((item) => ({
                                  label: item?.Name,
                                  value: item?.Id,
                                  id: item?.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    ) : (
                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={singleTaskTypeUpdate}
                          onChange={(e) => {
                            setSingleTaskTypeUpdate(e);
                            setSingleItemCreateUpdate({
                              ...singleItemCreateUpdate,
                              OpportunityType_Id: e.id,
                            });
                          }}
                          options={
                            !isEmpty(opportunitiesTypeListData)
                              ? opportunitiesTypeListData?.map((item) => ({
                                  label: item?.Name,
                                  value: item?.Id,
                                  id: item?.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    )}
                  </div>
                </Col>
                <Col lg={12}>
                  <div>
                    <Label htmlFor="company_name-field" className="form-label">
                      Opportunity Priority
                    </Label>
                    {!!isEdit ? (
                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={singleOpportunityPriorityUpdate}
                          onChange={(e) => {
                            setSingleOpportunityPriorityUpdate(e);
                            setSingleItemCreateUpdate({
                              ...singleItemCreateUpdate,
                              OpportunityPriority_Id: e.id,
                            });
                          }}
                          options={
                            !isEmpty(opportunitiesPriorityListData)
                              ? opportunitiesPriorityListData?.map((item) => ({
                                  label: item?.Name,
                                  value: item?.Id,
                                  id: item?.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    ) : (
                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={singleOpportunityPriorityUpdate}
                          onChange={(e) => {
                            setSingleOpportunityPriorityUpdate(e);
                            setSingleItemCreateUpdate({
                              ...singleItemCreateUpdate,
                              OpportunityPriority_Id: e.id,
                            });
                          }}
                          options={
                            !isEmpty(opportunitiesPriorityListData)
                              ? opportunitiesPriorityListData?.map((item) => ({
                                  label: item?.Name,
                                  value: item?.Id,
                                  id: item?.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    )}
                  </div>
                </Col>
                <Col lg={12}>
                  <div>
                    <Label htmlFor="company_name-field" className="form-label">
                      Due Date
                    </Label>
                    {!!isEdit ? (
                      <div>
                        <AppDatePicker
                          slotProps={{
                            textField: { placeholder: "Select Due date" },
                          }}
                          value={
                            singleItemCreateUpdate.DueDateTime
                              ? moment(singleItemCreateUpdate.DueDateTime)
                              : null
                          }
                          onChange={(val) => {
                            const jsDate =
                              val && val.isValid() ? val.toDate() : null;
                            setSingleItemCreateUpdate({
                              ...singleItemCreateUpdate,
                              DueDateTime: jsDate ? handleDateFormat(jsDate) : "",
                            });
                          }}
                        />
                      </div>
                    ) : (
                      <div>
                        <AppDatePicker
                          slotProps={{
                            textField: { placeholder: "Select Due date" },
                          }}
                          value={
                            singleItemCreateUpdate.DueDateTime
                              ? moment(singleItemCreateUpdate.DueDateTime)
                              : null
                          }
                          onChange={(val) => {
                            const jsDate =
                              val && val.isValid() ? val.toDate() : null;
                            setSingleItemCreateUpdate({
                              ...singleItemCreateUpdate,
                              DueDateTime: jsDate ? handleDateFormat(jsDate) : "",
                            });
                          }}
                        />
                      </div>
                    )}
                  </div>
                </Col>

                {isCreate && (
                  <Col lg={12}>
                    <div>
                      <Label className="form-label">
                        Products / Services of Interest
                      </Label>
                      <Row className="g-2 align-items-end">
                        <Col lg={7}>
                          <Select
                            className="mb-0 job-select2"
                            placeholder="Select a product or service"
                            value={productPicker}
                            onChange={(e) => setProductPicker(e)}
                            options={
                              !isEmpty(productList)
                                ? productList?.filter(isProductActive).map((item) => ({
                                    label:
                                      item.NameCustomerFacing || item.Name,
                                    value: item.Id,
                                    id: item.Id,
                                  }))
                                : []
                            }
                          />
                        </Col>
                        <Col lg={3}>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            className="form-control"
                            placeholder="Qty"
                            value={productQty}
                            onChange={(e) => setProductQty(e.target.value)}
                          />
                        </Col>
                        <Col lg={2}>
                          <button
                            type="button"
                            className="btn btn-success w-100"
                            onClick={handleAddInterestedProduct}
                          >
                            Add
                          </button>
                        </Col>
                      </Row>

                      {!isEmpty(interestedProducts) && (
                        <ul className="list-group mt-2">
                          {interestedProducts.map((p) => (
                            <li
                              key={p.Product_Id}
                              className="list-group-item d-flex justify-content-between align-items-center"
                            >
                              <span>
                                {p.Product_Name}
                                <span className="text-muted ms-2">
                                  x {p.Quantity}
                                </span>
                              </span>
                              <button
                                type="button"
                                className="btn btn-sm btn-soft-danger"
                                onClick={() =>
                                  handleRemoveInterestedProduct(p.Product_Id)
                                }
                              >
                                <i className="ri-delete-bin-line"></i>
                              </button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </Col>
                )}
              </Row>
        </>
      ) : null}
    </AppModal>
    </>
  );
}
